import axios from 'axios';
import envService from "@/services/env.service";
import {logger} from "@/services/logger.service";

const OAUTH2_LOGIN_BASE_URL = envService.getOAuth2LoginBaseUrl();

export const EVENT_LOGIN_CHANGED = "login-changed";

export default {
    async providerLogin(provider, code, state) {
        return await axios.get(OAUTH2_LOGIN_BASE_URL + '/' + provider,
            {params: {code: code, state: state}})
            .then(response => {
                logger.info("Login with provider " + provider + " successful.");
                return response.data;
            })
            .catch(error => {
                logger.error("Error during login with provider " + provider, error);
                throw error;
            })
            .finally(() => logger.info("Call finished!"));
    }
}
